// extracted by mini-css-extract-plugin
module.exports = {"content-social":"content-social","btn-social":"btn-social","btn-like":"btn-like","icon":"icon","is-like":"is-like","btn-zalo":"btn-zalo","btn-facebook":"btn-facebook"};